import { render, staticRenderFns } from "./newAsideRight.vue?vue&type=template&id=a189d5b4&"
import script from "./newAsideRight.vue?vue&type=script&lang=js&"
export * from "./newAsideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports